import api from "../../api/index";

const getwalletdetails = `${process.env.VUE_APP_BASE_URI}/wallet/sms/overview`;

const getpurchasehistory = `${process.env.VUE_APP_BASE_URI}/wallet/sms/transactions`;

const getsmssettings = `${process.env.VUE_APP_BASE_URI}/wallet/sms/settings`;
const getsmsunits = `${process.env.VUE_APP_BASE_URI}/wallet`;
const updateSmsSettings = `${process.env.VUE_APP_BASE_URI}/wallet`;
const purchaseSms = `${process.env.VUE_APP_BASE_URI}/wallet/sms/purchase`;
const customPurchase = `${process.env.VUE_APP_BASE_URI}/wallet/sms/customPurchase`;

const getDefaultState = () => {
  return {
    walletDetail: [],
    walletHistory: [],
    filteredSmsLogs: [],
    smsSettings: [],
    status: "",
    msg: "",
    errMsg: "",
    smsUnits: {},
    filteredPurchaseHistory: [],
    walletDetailMeta: {},
  };
};

const state = getDefaultState();

const getters = {
  walletDetail: (state) => state.walletDetail,
  filteredSmsLogs: (state) => state.filteredSmsLogs,
  filteredPurchaseHistory: (state) => state.filteredPurchaseHistory,
  smsSettings: (state) => state.smsSettings,
  smsNotification: (state) => state.msg,
  getWalletErrMsg: (state) => state.errMsg,
  smsUnits: (state) => state.smsUnits,
  walletHistory: (state) => state.walletHistory,
  walletDetailMeta: (state) => state.walletDetailMeta,
};

const actions = {
  async getwalletdetails({ commit }, params) {
    commit("getwalletdetail_request");
    const res = await api.get(getwalletdetails, { params });
    if (res.data.success) {
      commit("getwalletdetail_success", res.data.payload);
    }
    return res;
  },
  async getpurchasehistory({ commit }, params) {
    commit("getpurchasehistory_request");
    const res = await api.get(getpurchasehistory, { params });
    if (res.data.success) {
      commit("getpurchasehistory_success", res.data.payload);
    }
    return res;
  },
  async getSmsSettings({ commit }) {
    commit("getsmssettings_request");
    const res = await api.get(getsmssettings);
    if (res.data.success) {
      commit("getsmssettings_success", res.data.payload);
    }
    return res;
  },
  async getsmsunits({ commit }) {
    commit("getsmsunits_reqeust");
    const res = await api.get(getsmsunits);
    if (res.data.success) {
      commit("getsmsunits_success", res.data.payload);
    }
    return res;
  },
  async getFilteredSmsLogs({ commit }, period) {
    commit("getFilteredSmsLogs_request");
    const res = await api.post(getwalletdetails, period);
    if (res.data.success) {
      commit("getFilteredSmsLogs_success", res.data.data);
    }
    return res;
  },
  async getFilteredPurchaseHistory({ commit }, period) {
    commit("getFilteredPurchaseHistory_request");
    const res = await api.post(customPurchase, period);
    if (res.data.success) {
      commit("getFilteredPurchaseHistory_success", res.data.data);
    }
    return res;
  },
  async updateSmsSettings({ commit }, { data, id }) {
    commit("updateSmsSettings_request");
    const res = await api.patch(`${updateSmsSettings}/${id}`, data);
    if (res.data.success) {
      commit("updateSmsSettings_success", res.data.message);
    }
    return res;
  },
  async purchaseSms({ commit }, data) {
    commit("purchaseSms_request");
    const res = await api.post(purchaseSms, data);
    if (res.data.success) {
      commit("purchaseSms_success", res.data.message);
    }
    return res;
  },

  async updateErrMsg({ commit }, data) {
    await commit("updateerrmsg_success", data);
  },
  async updateMsg({ commit }, data) {
    await commit("updateMsg_success", data);
  },

  async resetSMSState({ commit }) {
    await commit("resetsmsstate_success");
  },
};

const mutations = {
  getwalletdetail_request: (state) => (state.status = "loading"),
  getwalletdetail_success: (state, data) => {
    state.status = "success";
    state.walletDetail = data.data;
    state.walletDetailMeta = data.meta;
  },
  getpurchasehistory_request: (state) => (state.status = "loading"),
  getpurchasehistory_success: (state, data) => {
    state.status = "success";
    state.walletHistory = data;
  },
  getFilteredSmsLogs_request: (state) => (state.status = "loading"),
  getFilteredSmsLogs_success: (state, data) => {
    state.status = "success";
    state.filteredSmsLogs = data;
  },
  getFilteredPurchaseHistory_request: (state) => (state.status = "loading"),
  getFilteredPurchaseHistory_success: (state, data) => {
    state.status = "success";
    state.filteredPurchaseHistory = data;
  },
  getsmssettings_request: (state) => (state.status = "loading"),
  getsmssettings_success: (state, data) => {
    state.status = "success";
    state.smsSettings = data;
  },
  getsmsunits_reqeust: (state) => (state.status = "loading"),
  getsmsunits_success: (state, data) => {
    state.status = "success";
    state.smsUnits = data;
  },
  updateSmsSettings_request: (state) => (state.status = "loading"),
  updateSmsSettings_success: (state, data) => {
    state.status = "success";
    state.msg = data;
    setTimeout(() => {
      state.msg = "";
    }, 7000);
  },
  purchaseSms_request: (state) => (state.status = "loading"),
  purchaseSms_success: (state, data) => {
    state.status = "success";
    state.msg = data;
    setTimeout(() => {
      state.msg = "";
    }, 7000);
  },

  resetsmsstate_success: (state) => Object.assign(state, getDefaultState()),
  updateerrmsg_success: (state, data) => (state.errMsg = data),
  updateMsg_success: (state, data) => (state.msg = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
